import PropTypes from "prop-types";
import { cn } from "@/lib/utils";
import logoFull from "@/assets/brand/sellyx-logo.png";
import logoMark from "@/assets/brand/sellyx-mark.png";

/**
 * Sellyx brand mark.
 * - withText: full lockup (icon + SellyX + tagline)
 * - without: icon-only mark (sidebar collapsed, compact nav)
 */
export function Logo({ size = 22, className, withText = true }) {
  if (withText) {
    // Full lockup is ~2:1; size maps to height so wordmark stays readable.
    const height = Math.max(size * 1.65, 28);
    return (
      <div className={cn("inline-flex items-center", className)} data-testid="sellix-logo">
        <img
          src={logoFull}
          alt="Sellyx — Your Personal AI Sales Coworker"
          height={height}
          style={{ height, width: "auto", display: "block", mixBlendMode: "multiply" }}
          draggable={false}
        />
      </div>
    );
  }

  return (
    <div className={cn("inline-flex items-center justify-center", className)} data-testid="sellix-logo">
      <img
        src={logoMark}
        alt="Sellyx"
        width={size}
        height={size}
        style={{ width: size, height: size, display: "block", objectFit: "contain", mixBlendMode: "multiply" }}
        draggable={false}
      />
    </div>
  );
}

Logo.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  withText: PropTypes.bool,
};
